import React from "react";
import {
  Collapse,
  Button,
  InputGroup,
  FormControl,
  Alert,
  Glyphicon,
  DropdownButton,
  MenuItem,
} from "react-bootstrap";
import { RelatedObjectSubItem } from "./RelatedObjectSubItem";
import { CubeStructureItem } from "./CubeStructureItem";
import { Pagination } from "../search/Pagination";
import ListSearch from "../bucket/ListSearch";
import BucketSearch from "../bucket/BucketSearch";
import { observer, inject } from "mobx-react";
import { CustomTooltip } from "../tooltip/CustomTooltip";
import { CubeTypeGroup } from "./CubeTypeGroup";
import VariableTree from "./VariableTree";
import { ExactMatchSearchItem } from "../search/ExactMatchSearchItem";
import { withRouter } from "../../utils/Utils";
import { StoreContext } from "../../contexts/StoreContext";
import FullProfileComponent from "../navigation/FullProfileComponent";

import "./VariableTree.scss";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

@inject("detailViewStore", "searchStore", "previewStore")
@observer
export class RelatedObjectItemComponent extends React.Component {
  constructor(props) {
    super(props);

    const variableMembers =
      this.props.type === "Members" && this.props.typeView === "Variable";

    this.state = {
      open: this.props.type === "Cubes" || variableMembers,
      openItems: [],
      searchExpr: "",
      frameworks: null,
    };
  }

  componentDidMount() {
    const { getMacroFrameworksMaintenanceAgencies, searchFramework } =
      this.props.searchStore;
    const { getEntityData } = this.context;
    const maintenanceAgenciesToExclude = getMacroFrameworksMaintenanceAgencies;
    this.context.setSearchMatrix("relCubes", "");
    const params = new URLSearchParams(window.location.search);
    let selectedFramework = params.get("framework");

    if (this.props.typeView === "Variable" && this.props.type === "Members") {
      if (selectedFramework || searchFramework)
        this.updateStoreWithQueryParams();
      else if (
        this.props.searchStore.getSelectedFramework &&
        !maintenanceAgenciesToExclude.includes(
          this.props.searchStore.getSelectedFramework.maintenanceAgencyId
        ) &&
        this.props.searchStore.getSelectedFramework.type !== "FrameworkGroup"
      ) {
        if (!selectedFramework) {
          let frameworkOptions =
            getEntityData.item.navigationLookupResult.navigationLookupBuckets &&
            getEntityData.item.navigationLookupResult.navigationLookupBuckets
              .Frameworks &&
            getEntityData.item.navigationLookupResult.navigationLookupBuckets
              .Frameworks.objects
              ? getEntityData.item.navigationLookupResult
                  .navigationLookupBuckets.Frameworks.objects
              : [];
          let selectedFrameworks = frameworkOptions?.find(
            (framework) =>
              framework.name ===
              this.props.searchStore.getSelectedFramework.name
          );
          if (selectedFrameworks) {
            this.setState({
              frameworks: this.props.searchStore.getSelectedFramework,
            });
            const url = new URL(window.location);
            url.searchParams.set(
              "framework",
              this.props.searchStore.getSelectedFramework.name
            );
            window.history.pushState({}, null, url);
          } else
            this.setState({
              frameworks: "all",
            });
        }
      } else this.updateStoreWithQueryParams();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      if (this.props.typeView === "Variable" && this.props.type === "Members") {
        this.updateStoreWithQueryParams();
      }
    }
  }

  updateStoreWithQueryParams = () => {
    const { getEntityData } = this.context;
    const { getMacroFrameworksMaintenanceAgencies, searchFramework } =
      this.props.searchStore;
    const maintenanceAgenciesToExclude = getMacroFrameworksMaintenanceAgencies;
    let frameworkOptions =
      getEntityData.item?.navigationLookupResult.navigationLookupBuckets &&
      getEntityData.item?.navigationLookupResult.navigationLookupBuckets
        .Frameworks &&
      getEntityData.item?.navigationLookupResult.navigationLookupBuckets
        .Frameworks.objects
        ? getEntityData.item?.navigationLookupResult.navigationLookupBuckets
            .Frameworks.objects
        : [];
    const params = new URLSearchParams(window.location.search);
    if (searchFramework) {
      frameworkOptions = frameworkOptions.filter(
        (framework) =>
          framework.type === "Framework" &&
          !maintenanceAgenciesToExclude.includes(framework.maintenanceAgencyId)
      );
      let IsselectedFrameworkValid = frameworkOptions?.find(
        (framework) => framework.code === searchFramework.code
      );
      if (IsselectedFrameworkValid) {
        this.setState({ frameworks: IsselectedFrameworkValid });
        const url = new URL(window.location);
        url.searchParams.set("framework", searchFramework.code);
        if (this.context === this.props.detailViewStore)
          window.history.pushState({}, null, url);
        return;
      }
    }
    let selectedFramework = params.get("framework");
    frameworkOptions = frameworkOptions.filter(
      (framework) =>
        framework.type === "Framework" &&
        !maintenanceAgenciesToExclude.includes(framework.maintenanceAgencyId)
    );
    selectedFramework = frameworkOptions?.find(
      (framework) => framework.code === selectedFramework
    );
    if (selectedFramework) this.setState({ frameworks: selectedFramework });
    else this.setState({ frameworks: "all" });
  };

  handleCollapse = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handleFrameworkChange = (framework) => {
    this.setState({ frameworks: framework });
    const url = new URL(window.location);
    if (framework === "all") {
      this.props.searchStore.setSearchFramework("All applicable Frameworks");
    }
    if (framework && framework !== "all") {
      url.searchParams.set("framework", framework?.code ? framework.code : "");
      if (framework.code)
        this.props.searchStore.setSearchFramework(framework.code);
    } else if (url.searchParams.get("framework")) {
      url.searchParams.delete("framework");
    }
    window.history.pushState({}, null, url.toString());
  };
  getFrameworkOptions = (frameworks) => {
    if (!frameworks || frameworks.length < 1) return null;
    return frameworks
      .sort((f1, f2) => {
        if (f1.name > f2.name) return 1;
        if (f2.name > f1.name) return -1;
        return 0;
      })
      .map((framework) => (
        <MenuItem
          key={framework.code}
          value={framework.tid}
          onSelect={() => {
            this.handleFrameworkChange(framework);
          }}
          active={frameworks && frameworks.tid === framework.tid}
          title={framework.code}
          className={
            framework.type === "Framework"
              ? framework.maintenanceAgencyId === "ECB"
                ? "ref"
                : "nonref"
              : ""
          }
        >
          {framework.name}
        </MenuItem>
      ));
  };

  renderItems = (items) => {
    return items.length ? (
      <div className="item-list-container">
        {items.map((item, key) =>
          item.object && item.object.type === "CubeStructureItem" ? (
            <CubeStructureItem item={item} key={key} />
          ) : (
            <RelatedObjectSubItem item={item} key={key} />
          )
        )}
      </div>
    ) : (
      "Nothing found"
    );
  };

  getCubesWithCubeHierarchy = () => {
    const { getEntityData } = this.context;
    const cubeLists = { ...getEntityData.item.otherInformation };
    if (
      cubeLists &&
      cubeLists.cubeHierarchyMap &&
      cubeLists.cubeHierarchyMap.length > 0
    ) {
      return Object.entries(cubeLists.cubeHierarchyMap[0])
        .map(([key, value]) => {
          return {
            type: key,
            items: value,
          };
        })
        .filter((item) => item.items.length > 0);
    } else {
      return [];
    }
  };

  getTotalCubesNumber() {
    const { bucket } = this.props;
    const cubeLists = {
      ...this.context.getEntityData.item.otherInformation,
    };
    let sum = 0;
    if (
      cubeLists &&
      cubeLists.cubeHierarchyMap &&
      cubeLists.cubeHierarchyMap.length > 0
    ) {
      Object.entries(cubeLists.cubeHierarchyMap[0]).forEach(([key, value]) => {
        value.map((item) => (sum += item.sddCubes.length));
      });
    }
    return bucket.bucketType === "Cube"
      ? sum + bucket.totalCountOfObjects
      : bucket.totalCountOfObjects;
  }

  handleOpenChange = (openItems) => {
    this.setState({ openItems });
  };

  expandAllVariables = (variableTree) => {
    const openItems = [];
    const processParent = (item, topLevelParent) => {
      const nodes = item.nodes ? item.nodes : [];
      openItems.push(item.variable.tid);
      if (nodes.length > 0) {
        nodes.forEach((node) => {
          processParent(node, topLevelParent);
        });
      }
    };
    variableTree.forEach((item) => {
      processParent(item, item);
    });
    return openItems;
  };

  handleSearchExprChange = (searchExpr) => {
    this.setState({ searchExpr: searchExpr });
  };

  reset = () => {
    return [];
  };

  variableFilter = (variableTreeModel, text, filteredVariablesLength) => {
    const getNodes = (array, object) => {
      if (
        (object.variable.name &&
          object.variable.name.toLowerCase().includes(text.toLowerCase())) ||
        (object.variable.code &&
          object.variable.code.toLowerCase().includes(text.toLowerCase())) ||
        (object.variable.description &&
          object.variable.description
            .toLowerCase()
            .includes(text.toLowerCase()))
      ) {
        array.push(object);
        filteredVariablesLength.count++;
        return array;
      }
      if (Array.isArray(object.nodes)) {
        const nodes = object.nodes.reduce(getNodes, []);
        if (nodes.length) array.push({ ...object, nodes });
      }
      return array;
    };
    return variableTreeModel.reduce(getNodes, []);
  };

  calculateSizeOfTree = (model) => {
    let length = 0;
    const processItem = (item) => {
      length++;
      if (item.nodes) {
        item.nodes.forEach((child) => {
          processItem(child);
        });
      }
    };
    if (model && model.length) {
      model.forEach((child) => {
        processItem(child);
      });
    }
    return length;
  };

  static contextType = StoreContext;
  render() {
    const {
      bucket,
      type,
      setCurrentPage,
      setPerPage,
      setSearchExpression,
      fetchEntityDetails,
    } = this.props;
    if (this.props.typeView === "Variable" && type === "Primary Variables") {
      return null;
    }

    const { getMacroFrameworksMaintenanceAgencies } = this.props.searchStore;
    const { getEntityData } = this.context;
    const { frameworks } = this.state;

    let currentFrameworks;
    if (getEntityData.item.object.type === "Framework") {
      currentFrameworks = getEntityData.item.object.code;
    }

    let frameworkOptions;

    frameworkOptions =
      getEntityData.item.navigationLookupResult.navigationLookupBuckets &&
      getEntityData.item.navigationLookupResult.navigationLookupBuckets
        .Frameworks &&
      getEntityData.item.navigationLookupResult.navigationLookupBuckets
        .Frameworks.objects
        ? getEntityData.item.navigationLookupResult.navigationLookupBuckets
            .Frameworks.objects
        : [];

    const maintenanceAgenciesToExclude = getMacroFrameworksMaintenanceAgencies;
    const ref = this.getFrameworkOptions(
      frameworkOptions.filter(
        (framework) =>
          framework.type === "Framework" &&
          framework.maintenanceAgencyId === "ECB" &&
          !maintenanceAgenciesToExclude.includes(framework.maintenanceAgencyId)
      )
    );

    const nonref = this.getFrameworkOptions(
      frameworkOptions.filter(
        (framework) =>
          framework.type === "Framework" &&
          framework.maintenanceAgencyId !== "ECB" &&
          !maintenanceAgenciesToExclude.includes(framework.maintenanceAgencyId)
      )
    );

    const groups = this.getFrameworkOptions(
      frameworkOptions.filter(
        (framework) => framework.type === "FrameworkGroup"
      )
    );

    const {
      getAdditionalQueryParams,
      shouldDisplayPublishedCubesOfFramework,
      fetchingDataStatus,
    } = this.context;
    if (
      !bucket ||
      (this.props.typeView === "Domain" &&
        type === "Primary Variables" &&
        fetchingDataStatus.get("Variables") === false)
    ) {
      return null;
    }
    const { perPage, currentPage, searchExpression } =
      getAdditionalQueryParams[type];
    const total = bucket.totalCountOfObjects;
    const searchExpr = this.context.getSearchMatrix["relCubes"] || "";

    let filtered = 0;
    let cubesWithHierarchy = [];
    let cubesWithHierarchiesFilteredLength = 0;
    if (type === "Cubes") {
      cubesWithHierarchy = this.getCubesWithCubeHierarchy();
      // filter to split display of published cubes and unpublished cubes for related framework
      // also for domain view because it uses the same variable tree display as framework view
      if (
        IS_BIRD_APP &&
        (this.props.typeView?.toLowerCase() === "framework" ||
          this.props.typeView?.toLowerCase() === "domain")
      ) {
        bucket.objects = shouldDisplayPublishedCubesOfFramework
          ? bucket.objects.filter((cube) => cube.published)
          : bucket.objects.filter((cube) => !cube.published);

        bucket.totalCountOfObjects = bucket.objects.length;
        cubesWithHierarchy.forEach((cubeHierarchy) => {
          cubeHierarchy.items.forEach((item) => {
            item.sddCubes = shouldDisplayPublishedCubesOfFramework
              ? item.sddCubes.filter((cube) => cube.published)
              : item.sddCubes.filter((cube) => !cube.published);
          });
        });
      }
      const cubesWithHierarchyFiltered =
        this.context.applyFiltersWithCubeHierarchy(
          cubesWithHierarchy,
          searchExpr
        );
      if (cubesWithHierarchyFiltered && cubesWithHierarchyFiltered.length > 0)
        cubesWithHierarchiesFilteredLength = cubesWithHierarchyFiltered.reduce(
          (prevCount, currentCubeType) =>
            prevCount +
            currentCubeType.items.reduce((x, y) => {
              return x + y.sddCubes.length;
            }, 0),
          0
        );
      filtered = this.context.applyFilters(bucket.objects, searchExpr).length;
    }

    let variableTreeModel;
    if (
      this.context &&
      this.context.entityData &&
      this.context.entityData.item &&
      this.context.entityData.item.otherInformation &&
      this.context.entityData.item.otherInformation.VariableTree
    ) {
      variableTreeModel =
        this.context.entityData.item.otherInformation.VariableTree;
    }
    let filteredVariablesLength = { count: 0 };
    const totalVariablesLength = this.calculateSizeOfTree(variableTreeModel);
    let currentVariablesLength = totalVariablesLength;
    if (
      type === "Variables" &&
      variableTreeModel &&
      this.state.searchExpr !== ""
    ) {
      variableTreeModel = this.variableFilter(
        variableTreeModel,
        this.state.searchExpr,
        filteredVariablesLength
      );
      currentVariablesLength = filteredVariablesLength.count;
    }
    const totalCubesNumber = this.getTotalCubesNumber();

    let displayCount = "";
    switch (type) {
      case "Cubes":
        displayCount = `${
          filtered + cubesWithHierarchiesFilteredLength
        }/${totalCubesNumber}`;
        break;
      case "Variables":
        if (this.props.typeView === "Framework") {
          displayCount = `${currentVariablesLength}/${totalVariablesLength}`;
        } else if (this.props.typeView === "Domain") {
          displayCount = currentVariablesLength;
        } else {
          displayCount = total;
        }
        break;
      default:
        displayCount = total;
    }

    let panelName = "";
    switch (type) {
      case "Cubes":
        panelName = (
          <span style={{ display: "inline-flex" }}>
            Data models <CustomTooltip type="CubeHierarchy" /> and Cubes{" "}
            <CustomTooltip type="Cube" />
          </span>
        );
        break;
      case "Members":
        if (this.props.typeView === "Variable") {
          panelName = "Members [allowed values]";
        } else {
          panelName = bucket.bucketName;
        }
        break;
      default:
        panelName = bucket.bucketName;
    }

    let component = "";
    switch (type) {
      case "Cubes":
        component = (
          <React.Fragment>
            <div style={{ display: "flex" }}>
              <ListSearch
                searchMatrixKey={"relCubes"}
                placeholder={"Filter by Name or Code"}
              />{" "}
              <FullProfileComponent
                shoulPageReload={true}
                selectedUserProfileId={
                  this.props.searchStore.getSelectedUserProfile.id
                }
                customMessage={"Looking for more Layers ? Try the "}
              ></FullProfileComponent>
            </div>
            {/* this applies to framework view - we mimic exactly one owning framework because of default expanding */}
            <CubeTypeGroup
              cubes={bucket.objects}
              searchExpr={searchExpr}
              frameworks={[{}]}
              cubesWithHierarchy={cubesWithHierarchy}
            />
          </React.Fragment>
        );
        break;
      case "Variables":
        if (
          this.props.typeView === "Framework" ||
          this.props.typeView === "Domain"
        ) {
          component = (
            <React.Fragment>
              <div className="sdd-variable-tree-controls-container">
                <div className="sdd-variable-tree-search-field-container">
                  <InputGroup>
                    <FormControl
                      type="text"
                      value={this.state.searchExpr}
                      onChange={(event) =>
                        this.handleSearchExprChange(event.target.value)
                      }
                      placeholder={"Variable Name, Code or Description..."}
                      bsSize="small"
                    />
                    <InputGroup.Button>
                      <Button
                        onClick={() => {
                          this.handleSearchExprChange("");
                        }}
                        bsSize="small"
                      >
                        Clear
                      </Button>
                      <Button
                        onClick={() => {
                          this.setState({
                            openItems: this.expandAllVariables(
                              this.context.entityData.item.otherInformation
                                .VariableTree
                            ),
                          });
                        }}
                        bsSize="small"
                      >
                        Expand All
                      </Button>
                      <Button
                        onClick={() => {
                          this.setState({
                            openItems: this.reset(),
                          });
                        }}
                        bsSize="small"
                      >
                        Collapse All
                      </Button>
                    </InputGroup.Button>
                  </InputGroup>
                </div>
              </div>
              <VariableTree
                framework={currentFrameworks ? currentFrameworks : null}
                model={variableTreeModel}
                onOpenChange={this.handleOpenChange}
                openItems={this.state.openItems}
                searchExpr={this.state.searchExpr}
              />
            </React.Fragment>
          );
        }
        break;
      default:
        component = (
          <React.Fragment>
            <div className="bucket-pagination-container">
              <BucketSearch
                getSearchExpression={searchExpression}
                setSearchExpression={setSearchExpression}
                fetchSearchResults={fetchEntityDetails}
                setCurrentPage={setCurrentPage.bind(this, type)}
                type={type}
              />
              <Pagination
                fetchSearchResults={fetchEntityDetails}
                setCurrentPage={setCurrentPage.bind(this, type)}
                setPerPage={setPerPage.bind(this, type)}
                perPage={perPage}
                currentPage={currentPage}
                searchQuery={searchExpression}
                totalResults={total}
              />
            </div>

            {total ? (
              <p>
                <em>
                  {`Showing ${
                    currentPage === 1 ? 1 : (currentPage - 1) * perPage + 1
                  } - ${
                    total < perPage || currentPage * perPage > total
                      ? total
                      : currentPage * perPage
                  } of ${total} results`}
                </em>
              </p>
            ) : (
              ""
            )}

            {this.renderItems(bucket.objects)}

            <div className="bucket-pagination-container">
              {total > perPage && perPage >= 100 ? (
                <Pagination
                  fetchSearchResults={fetchEntityDetails}
                  setCurrentPage={setCurrentPage.bind(this, type)}
                  setPerPage={setPerPage.bind(this, type)}
                  perPage={perPage}
                  currentPage={currentPage}
                  searchQuery={searchExpression}
                  totalResults={total}
                />
              ) : (
                ""
              )}
            </div>
          </React.Fragment>
        );
    }

    const variableMembers =
      type === "Members" && this.props.typeView === "Variable";
    const memberAlert = variableMembers && (
      <>
        {this.context !== this.props.previewStore && (
          <Alert bsStyle="warning">
            <div>
              <Glyphicon glyph="info-sign" />
              Select the Framework of interest to limit the values to those
              applicable in any Cube (entity) of the Framework.
            </div>
          </Alert>
        )}
        {this.context === this.props.previewStore &&
        !this.props.searchStore.macroFrameworksMaintenanceAgencies.includes(
          frameworks?.maintenanceAgencyId
        ) &&
        !frameworkOptions.find(
          (framework) =>
            framework?.tid === frameworks?.tid || framework?.name === frameworks
        ) ? (
          <Alert bsStyle="warning">
            <div>
              <Glyphicon glyph="info-sign" />
              This Variable is not included in this Framework, please select a
              more specific Variable to show which allowed values are included
              in this Framework.
            </div>
          </Alert>
        ) : null}
        <div style={{ margin: " 0 0 20px 0" }}>
          <div>Framework:</div>
          <DropdownButton
            closeonchange={"true"}
            id={"framework-search"}
            disabled={this.context === this.props.previewStore}
            title={(() => {
              let label = "All applicable Frameworks";
              if (frameworks) {
                const target = frameworkOptions.find(
                  (framework) =>
                    framework.tid === frameworks.tid ||
                    framework.name === frameworks
                );
                if (target) {
                  label = target.name;
                }
              }
              return label;
            })()}
          >
            <MenuItem
              key={"all"}
              onSelect={() => this.handleFrameworkChange("all")}
              active={this.state.frameworks === "all"}
            >
              All applicable Frameworks
            </MenuItem>
            {ref ? <MenuItem divider /> : null}
            {ref}
            {nonref ? <MenuItem divider /> : null}
            {nonref}
            {groups ? <MenuItem divider /> : null}
            {groups}
          </DropdownButton>
        </div>
      </>
    );

    const entityData = this.context.entityData.item;
    const exportVariableMembers = (
      <>
        {entityData &&
          entityData.navigationLookupResult &&
          entityData.navigationLookupResult.navigationLookupBuckets &&
          entityData.navigationLookupResult.navigationLookupBuckets[
            "Members"
          ] &&
          entityData.navigationLookupResult.navigationLookupBuckets["Members"]
            .objects &&
          entityData.navigationLookupResult.navigationLookupBuckets["Members"]
            .objects.length > 0 &&
          this.props.type === "Members" && (
            <div
              className="custom-export-alignament"
              onClick={() =>
                this.context.exportVariableMembers(entityData, false)
              }
            >
              <h5> Excel export</h5>
              <span
                className="glyphicon glyphicon-download-alt"
                style={{ float: "right", cursor: "pointer" }}
              />
            </div>
          )}
      </>
    );

    const fetchingDataStatusType =
      type === "Primary Variables" ? "Variables" : type;
    return (
      <>
        {variableMembers ? (
          <>
            <div>
              <ExactMatchSearchItem
                item={getEntityData.item.object}
                framework={frameworks}
                exactSearchPerPage={100}
                openMemberPanel={true}
                hideDetails={true}
              >
                {memberAlert}
              </ExactMatchSearchItem>
            </div>
          </>
        ) : !!component ? (
          <div className="custom-panel bucket-search">
            <div className="custom-panel-heading">
              <h5 onClick={this.handleCollapse}>
                <Glyphicon
                  glyph={
                    !this.state.open || this.state.open === undefined
                      ? "chevron-right"
                      : "chevron-down"
                  }
                />{" "}
                {panelName} ({displayCount})
                {fetchingDataStatus.get(fetchingDataStatusType) === true ? (
                  <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                ) : (
                  ""
                )}
              </h5>
              <CustomTooltip
                type={
                  "Primary Variables" === bucket.bucketName
                    ? "PrimaryConcept"
                    : bucket.bucketName === "Cubes"
                    ? ""
                    : bucket.bucketType
                }
              />
              {exportVariableMembers}
            </div>
            <Collapse in={this.state.open}>
              <div>
                {memberAlert}
                <div className="custom-panel-body">{component}</div>
              </div>
            </Collapse>
          </div>
        ) : null}
      </>
    );
  }
}

const RelatedObjectItem = withRouter(RelatedObjectItemComponent);
export { RelatedObjectItem };
